export const permGPRefresh = "GPRefresh";
